import AddBankAccount from "@/views/info/AddBankAccount";
import AddCryptoAccount from "@/views/info/AddCryptoAccount";
import AddOthersAccount from "@/views/info/AddOthersAccount";
import BankInformation from "@/views/info/BankInformation";
import AddLocalBankAccount from "@/views/info/AddLocalBankAccount";

export default {
  BankInformation,
  AddBankAccount,
  AddOthersAccount,
  AddCryptoAccount,
  AddLocalBankAccount,
};